import { Button } from '@uhg-abyss/web/ui/Button';
import { find } from 'lodash';
import { useTranslation } from 'react-i18next';

import { ConstantsLagoon } from '../../../common/ConstantsLagoon';
import { useLagoon } from '../../../hooks/useLagoon';
import {
  ErrorHandlingContainer,
  UnableToLoadPlanHeading,
  UnableToLoadPlanText,
  goToUhcButtonStyles,
} from './PlanErrorScreen.styled';

export const PlanErrorScreen = () => {
  const { t } = useTranslation();
  const lagoonUIMessage = useLagoon('ui-messaging')();
  const myUhcUrl = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.UNABLE_TO_LOAD_PLAN,
  })?.url;

  const navigateToMyUhc = () => {
    window.location.href = myUhcUrl;
  };

  return (
    <ErrorHandlingContainer>
      <UnableToLoadPlanHeading data-testid="unable-to-load-plan-heading">
        {t('GUEST_UNABLE_TO_LOAD_PLAN_PAGE.HEADING')}
      </UnableToLoadPlanHeading>
      <UnableToLoadPlanText data-testid="unable-to-load-plan-text">
        {t('GUEST_UNABLE_TO_LOAD_PLAN_PAGE.CONTENT')}
      </UnableToLoadPlanText>
      <Button
        css={goToUhcButtonStyles}
        data-testid="go-to-uhc-button"
        onClick={navigateToMyUhc}
        size="lg"
      >
        {t('GUEST_UNABLE_TO_LOAD_PLAN_PAGE.UHC_BUTTON')}
      </Button>
    </ErrorHandlingContainer>
  );
};
